import { render, staticRenderFns } from "./PasswordResetForm.vue?vue&type=template&id=4ea81f85&scoped=true&lang=pug"
import script from "./PasswordResetForm.vue?vue&type=script&lang=js"
export * from "./PasswordResetForm.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetForm.vue?vue&type=style&index=0&id=4ea81f85&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea81f85",
  null
  
)

export default component.exports